import React, { useState, useEffect } from "react";
import "./EditNurse.css";
import Widgets from "../../../../widgets";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProgressBarDynamic from "../../../../widgets/ProgressBarforMangeNurse/ProgressBarDynamic";
import { faPlus, faTrash, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import SelectCard from "../../../../widgets/selectCard/selectCard";
import Icons from "../../../../Assets/Icons";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { resetGetNurseDetails, resetEditNurse } from "../../../../modules/NursignCare/ManageNurse/ManageNurseSlice";
import { getNurseDetails, getAllServices, getSubServices, getServiceItems, editNurse, deleteNurse } from "../../../../modules/NursignCare/ManageNurse/ManageNurseThunk";
import MultiSelector from "../../../../widgets/SelectDropdown/MultiSelector";
import useValidation from "../../../../utils/validators";
import ToastPopup from "../../../../widgets/Toast/toastPopup";
import strings from "../../../../utils/strings";

const EditNurse = () => {
  const { nurseId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const breadcrumbs = [t("nursing_care"), t("manage_nurse"), t("Nurse")];
  const paths = [strings.navigation.nurseList, strings.navigation.nurseList, strings.navigation.editNurse];
  const [isOn, setIsOn] = useState(false);
  const [selectedServiceGroups, setSelectedServiceGroups] = useState([]);
  const [subServiceGroupOptions, setSubServiceGroupOptions] = useState([]);
  const [selectedSubServiceGroups, setSelectedSubServiceGroups] = useState([]);
  const [serviceItemsOptions, setServiceItemsOptions] = useState([]);
  const [serviceGroupOptions, setServiceGroupOptions] = useState([]);
  const [selectedServiceItems, setSelectedServiceItems] = useState([]);
  const { validateEditNurse } = useValidation();
  const countries = [
    { code: "+1", alpha2code: "US" },
    { code: "+91", alpha2code: "IN" },
    { code: "+84", alpha2code: "VN" },
  ];
  const sufix = [{ title: t("mr") }, { title: t("mrs") }, { title: t("miss") }];
  const [selectedTitle, setSelectedTitle] = useState(t("mr"));
  const [showTitle, setShowTitle] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("+91");
  const [showDropdown, setShowDropdown] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [isPhotoUploaded, setIsPhotoUploaded] = useState(false);
  const { getNurseDetailsSuccess, getNurseDetailsErr, editNurseSuccess, editNurseErr, services = [] } = useSelector((state) => state.manageNurse || {});

  const toggleSwitch = () => {
    setIsOn(!isOn);
  };
  const handlePhotoUpload = ({ files }) => {
    if (files.length > 0) {
      const imageURL = URL.createObjectURL(files[0]); // Create a preview URL
      setUploadedImage(imageURL);
      setIsPhotoUploaded(true); // Set to true when an image is uploaded
    }
  };

  const handleCountryChange = (code) => {
    setSelectedCountry(code);
    setShowDropdown(false);
    setFormData((prevData) => ({
      ...prevData,
      countryCode: code,
    }));
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  const handleConfirmDelete = () => {
    dispatch(deleteNurse(nurseId))
      .unwrap()
      .then(() => {
        ToastPopup.success(t("nurseDeleted"));
        navigate(strings.navigation.nurseList);
      })
      .catch((error) => {
        ToastPopup.error(t("nurseNotDeleted"));
        console.error("Error deleting nurse:", error);
      })
      .finally(() => {
        setShowDeleteModal(false);
      });
  };

  const handleTitleChange = (title) => {
    setSelectedTitle(title);
    setShowTitle(false);
  };

  const [serviceGroups, setServiceGroups] = useState([{ id: 1, serviceGroup: "", subServiceGroup: "", serviceItems: "" }]);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    passportNumber: "",
    email: "",
    employeeId: "",
    phoneNumber: "",
    dateOfBirth: "",
    gender: "",
    languages: [],
    designation: "",
    address: "",
    countryCode: "+91",
    serviceGroups: serviceGroups,
    specialization: [],
    profilePhoto: "",
  });

  useEffect(() => {
    // Fetch all services when the component mounts
    dispatch(getAllServices())
      .unwrap()
      .then((response) => {
        const serviceOptions = response.data.services.map((service) => ({
          value: service._id,
          label: service.title,
        }));
        setServiceGroupOptions(serviceOptions);
      })
      .catch((error) => {
        console.error("Error fetching services:", error);
      });
  }, [dispatch]);

  useEffect(() => {
    dispatch(getNurseDetails(nurseId));
    return () => {
      dispatch(resetGetNurseDetails());
    };
  }, [nurseId, dispatch]);

  useEffect(() => {
    if (getNurseDetailsSuccess) {
      const nurse = getNurseDetailsSuccess.data.nurse;
      setFormData({
        nurseId: nurse._id,
        firstName: nurse.firstName,
        lastName: nurse.lastName,
        passportNumber: nurse.passportNumber,
        email: nurse.email,
        phoneNumber: nurse.phoneNumber,
        employeeId: nurse.employeeID,
        dateOfBirth: nurse.dateOfBirth,
        gender: nurse.gender,
        languages: nurse.languages || [],
        designation: nurse.designation,
        address: nurse.address,
        countryCode: nurse.countryCode || "+91",
        specialization: nurse.specialization || [],
        profilePhoto: nurse.profilePhoto || "",
      });
      setIsOn(nurse.isActive); // Set active status
      setSelectedCountry(nurse.countryCode || "+91");
      setSelectedTitle(nurse.title || "Mr.");
      // Set service groups if available
      const serviceGroups = [];
      const subServiceGroups = [];
      const serviceItems = [];

      // Loop through each specialization to populate the selected options
      nurse.specialization.forEach((spec) => {
        serviceGroups.push({
          value: spec.service._id,
          label: spec.service.title,
        });

        subServiceGroups.push({
          value: spec.subService._id,
          label: spec.subService.title,
        });

        serviceItems.push({
          value: spec._id,
          label: spec.title,
        });
      });

      // Set the selected options in state
      setSelectedServiceGroups(serviceGroups);
      setSelectedSubServiceGroups(subServiceGroups);
      setSelectedServiceItems(serviceItems);
    }
  }, [getNurseDetailsSuccess]);

  // const formattedDate = new Date(formData.dateOfBirth).toISOString().split('T')[0]; // Converts to YYYY-MM-DD

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    if (newValue.startsWith(" ")) {
      newValue = newValue.trimStart();
    }

    if (name === "dateOfBirth") {
      // Convert the date string to a Date object
      newValue = new Date(value).toISOString();
    }

    // Allow only alphabets in first name and last name
    if (name === "firstName" || name === "lastName") {
      newValue = newValue.replace(/[^a-zA-Z\s]/g, "");
    }

    // Email validation
    if (name === "email") {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(newValue)) {
        // Handle invalid email
        // ToastPopup.error(t("invalidEmail"))
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const { firstName, lastName, passportNumber, email, employeeId, phoneNumber, dateOfBirth, gender, languages, designation, address } = formData;

    const filledFields = [
      firstName.trim() !== "",
      lastName.trim() !== "",
      passportNumber.trim() !== "",
      email.trim() !== "",
      employeeId.trim() !== "",
      phoneNumber.trim() !== "",
      dateOfBirth.trim() !== "",
      gender.trim() !== "",
      languages.length > 0,
      designation.trim() !== "",
      address.trim() !== "",
      isPhotoUploaded,
      selectedServiceGroups.length > 0,
      selectedSubServiceGroups.length > 0,
      selectedServiceItems.length > 0,
    ].filter(Boolean).length;

    const totalFields = 15;
    const progressPercentage = (filledFields / totalFields) * 100;

    setProgress(parseFloat(progressPercentage.toFixed(2)));
  }, [formData, selectedServiceGroups, selectedSubServiceGroups, selectedServiceItems, isPhotoUploaded]);

  const handleLanguageChange = (selectedOptions) => {
    // Update the languages field with selected values
    setFormData((prevData) => ({
      ...prevData,
      languages: selectedOptions ? selectedOptions.map((option) => option.value) : [],
    }));
  };

  const options = [
    { value: "English", label: t("english") },
    { value: "Vietnamese", label: t("vietnamese") },
  ];

  useEffect(() => {
    dispatch(getAllServices());
    dispatch(getNurseDetails(nurseId));
    return () => {
      dispatch(resetGetNurseDetails());
    };
  }, [nurseId, dispatch]);

  const handleServiceGroupChange = (selectedOptions) => {
    setSelectedServiceGroups(selectedOptions);

    // Fetch sub-services for selected service groups
    const serviceIds = selectedOptions.map((option) => option.value);
    Promise.all(serviceIds.map((serviceId) => dispatch(getSubServices(serviceId)).unwrap()))
      .then((responses) => {
        const allSubServices = responses.flatMap((response) =>
          response.data.subServices.map((subService) => ({
            value: subService._id,
            label: subService.title,
          })),
        );
        // Remove duplicates
        const uniqueSubServices = Array.from(new Set(allSubServices.map((s) => s.value))).map((value) => allSubServices.find((s) => s.value === value));
        setSubServiceGroupOptions(uniqueSubServices);
      })
      .catch((error) => {
        console.error("Error fetching sub-services:", error);
      });
  };

  const handleSubServiceGroupChange = (selectedOptions) => {
    setSelectedSubServiceGroups(selectedOptions);

    // Fetch service items for selected sub-service groups
    const subServiceIds = selectedOptions.map((option) => option.value);
    const serviceIds = selectedServiceGroups.map((option) => option.value);

    Promise.all(serviceIds.flatMap((serviceId) => subServiceIds.map((subServiceId) => dispatch(getServiceItems({ serviceId, subServiceId })).unwrap())))
      .then((responses) => {
        const allServiceItems = responses.flatMap((response) =>
          response.data.serviceItems.map((item) => ({
            value: item._id,
            label: item.title,
          })),
        );
        // Remove duplicates
        const uniqueServiceItems = Array.from(new Set(allServiceItems.map((i) => i.value))).map((value) => allServiceItems.find((i) => i.value === value));
        setServiceItemsOptions(uniqueServiceItems);
      })
      .catch((error) => {
        console.error("Error fetching service items:", error);
      });
  };
  const handleSave = () => {
    // Prepare the payload for the nurse data
    const nursePayload = {
      ...formData,
      isActive: isOn,
      serviceGroups: serviceGroups.map((group, index) => ({
        serviceGroup: selectedServiceGroups[index]?.value || "",
        subServiceGroup: selectedSubServiceGroups[index]?.value || "",
        serviceItems: selectedServiceItems[index]?.value || "",
      })),
      profilePhoto: uploadedImage || formData.profilePhoto,
    };

    // Validate the form data and service groups
    const isValid = validateEditNurse(formData, {
      selectedServiceGroups,
      selectedSubServiceGroups,
      selectedServiceItems,
    });

    if (!isValid) {
      console.log("Validation failed. Please check the form data.");
      return; // Stop execution if validation fails
    }

    console.log("Nurse Payload:", nursePayload);

    dispatch(editNurse({ nurseId, nurseData: nursePayload })).unwrap();
  };

  useEffect(() => {
    if (editNurseErr) {
      ToastPopup.error(t("nurseNotUpdated"));
    }
    if (editNurseSuccess && editNurseSuccess.status === "success") {
      ToastPopup.success(t("nurseUpdated"));
      navigate(strings.navigation.nurseList);
    }
    dispatch(resetEditNurse());
  }, [editNurseSuccess, editNurseErr]);

  return (
    <div className="edit-nurse-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />

      <div className="edit-header-section">
        <div className="department-heading">{nurseId}</div>
        <div>
          <button className="edit-delete-button" onClick={() => setShowDeleteModal(true)}>
            {t("delete")}
          </button>
        </div>
      </div>

      <div className="edit-nurse-grid-container">
        <div className="edit-grid-item">
          <div className="edit-grid-item-1">
            <div className="edit-nurse-heading">{t("generalInfo")}</div>
            <div className="edit-nurse-heading-active">
              <p className="edit-nurse-heading-active-p">{isOn ? `${t("active")}` : `${t("inactive")}`}</p>
              <div className="toggle-container">
                <div className={`toggle-switch ${isOn ? "on" : "off"}`} onClick={toggleSwitch}>
                  <div className="toggle-knob"></div>
                </div>
              </div>
            </div>
          </div>
          <hr className="edit-nurse-hr" />

          <div className="edit-nurse-general-information">
            <div className="edit-nurse-general-information-1">
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">{t("firstName")}</div>
                <div className="edit-nurse-general-information-1-input">
                  <div className="phone-input">
                    <div className="country-code-dropdown sufix-code" onClick={() => setShowTitle(!showTitle)}>
                      {t(selectedTitle)}
                      <FontAwesomeIcon icon={faChevronDown} />
                      <div className="vertical-line"></div>
                    </div>
                    {showTitle && (
                      <div className="dropdown-modal sufix-modal">
                        {sufix.map((titles) => (
                          <div key={titles.title} onClick={() => handleTitleChange(titles.title)} className="dropdown-item">
                            {t(titles.title)}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <input type="text" name="firstName" placeholder={t("namePlaceholder")} autoComplete="off" className="edit-input-field-name" value={formData.firstName} onChange={handleChange} />
                </div>
              </div>
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">{t("placeholderLastName")}</div>
                <div className="edit-nurse-general-information-1-input">
                  <input type="text" name="lastName" placeholder={t("lastnamePlaceholder")} className="edit-input-field" autoComplete="off" value={formData.lastName} onChange={handleChange} />
                </div>
              </div>
            </div>

            <div className="edit-nurse-general-information-1">
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">{t("passportNumber")}</div>
                <div className="edit-nurse-general-information-1-input">
                  <input
                    type="text"
                    name="passportNumber"
                    placeholder={t("passportPlaceholder")}
                    autoComplete="off"
                    className="edit-input-field"
                    value={formData.passportNumber}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">{t("email")}</div>
                <div className="edit-nurse-general-information-1-input">
                  <input type="text" name="email" placeholder={t("emailPlaceholder")} autoComplete="off" className="edit-input-field" value={formData.email} onChange={handleChange} />
                </div>
              </div>
            </div>

            <div className="edit-nurse-general-information-1">
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">{t("employeeId")}</div>
                <div className="edit-nurse-general-information-1-input">
                  <input type="text" name="employeeId" autoComplete="off" placeholder={t("nationalIdPlaceholder")} className="edit-input-field" value={formData.employeeId} onChange={handleChange} />
                </div>
              </div>
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">{t("phoneNumber")}</div>
                <div className="edit-nurse-general-information-1-input">
                  <div className="phone-input">
                    <div className="country-code-dropdown" onClick={() => setShowDropdown(!showDropdown)}>
                      {selectedCountry}
                      <FontAwesomeIcon icon={faChevronDown} />
                      <div className="vertical-line"></div>
                    </div>
                    {showDropdown && (
                      <div className="dropdown-modal">
                        {countries.map((country) => (
                          <div key={country.code} onClick={() => handleCountryChange(country.code)} className="dropdown-item">
                            ({country.code})
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <input
                    type="text"
                    id="phoneNumber"
                    name="phoneNumber"
                    autoComplete="off"
                    placeholder={t("phonePlaceholder")}
                    className="edit-input-field-name"
                    required
                    value={formData.phoneNumber}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="edit-nurse-general-information-1">
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">{t("dob")}</div>
                <div className="edit-nurse-general-information-1-input">
                  <input
                    type="date"
                    name="dateOfBirth"
                    className="edit-input-field"
                    value={formData.dateOfBirth ? new Date(formData.dateOfBirth).toISOString().split("T")[0] : ""}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">{t("gender")}</div>
                <div className="edit-nurse-general-information-1-input-gender">
                  <div className="input-gender-section">
                    <input
                      type="radio"
                      id="male"
                      name="gender"
                      value="Male"
                      checked={formData.gender === "Male"}
                      onChange={(e) =>
                        setFormData((prevData) => ({
                          ...prevData,
                          gender: e.target.value,
                        }))
                      }
                      required
                    />
                    <label htmlFor="male">{t("male")}</label>
                  </div>
                  <div className="input-gender-section">
                    <input
                      type="radio"
                      id="female"
                      name="gender"
                      value="Female"
                      checked={formData.gender === "Female"}
                      onChange={(e) =>
                        setFormData((prevData) => ({
                          ...prevData,
                          gender: e.target.value,
                        }))
                      }
                      required
                    />
                    <label htmlFor="female">{t("female")}</label>
                  </div>
                </div>
              </div>
            </div>

            <div className="edit-nurse-general-information-1">
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">{t("language")}</div>
                <div className="edit-nurse-general-information-1-input">
                  <Select
                    id="languages"
                    name="languages"
                    placeholder={t("selectLang")}
                    required
                    isMulti
                    options={options}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={options.filter((option) => Array.isArray(formData.languages) && formData.languages.includes(option.value))}
                    onChange={handleLanguageChange}
                  />
                </div>
              </div>
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">{t("designation")}</div>
                <div className="edit-nurse-general-information-1-input">
                  <select
                    id="designation"
                    name="designation"
                    required
                    className="edit-section-option-input"
                    style={{ color: "gray" }}
                    value={formData.designation}
                    onChange={(e) => {
                      e.target.style.color = e.target.value ? "black" : "gray";
                      setFormData((prevData) => ({
                        ...prevData,
                        designation: e.target.value,
                      }));
                    }}
                  >
                    <option value="" disabled style={{ color: "gray" }}>
                      {t("selectDesignation")}
                    </option>
                    <option value="nurse" style={{ color: "black" }}>
                      {t("nurse")}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div className="edit-nurse-general-information-1">
              <div className="edit-nurse-general-information-1-section">
                <div className="edit-nurse-general-information-1-heading">{t("address")}</div>
                <div className="edit-nurse-general-information-1-input-1">
                  <input type="text" name="address" placeholder={t("addressPlaceholder")} autoComplete="off" className="edit-input-field" value={formData.address} onChange={handleChange} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="edit-nurse-grid-item">
          <div className="edit-grid-item-2">
            <div className="edit-nurse-progress">{t("inProgress")}</div>
            <ProgressBarDynamic value={progress} />
          </div>
          <div className="edit-grid-item-2">
            <div className="edit-nurse-heading ">{t("photo")}</div>
            <hr className="edit-nurse-photo-hr" />
            <div className="edit-nurse-photo-upload">
              <div className="edit-nurse-photo-container">
                <img src={uploadedImage || formData.profilePhoto || Icons.profileNurse} alt="Profile" />
              </div>
              <div className="select-card-container">
                <SelectCard onImageUpload={handlePhotoUpload} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="edit-grid-item-3">
        <div className="">
          <h2 className="edit-nurse-heading">{t("specialization")}</h2>
          <hr className="edit-nurse-hr" />
          {serviceGroups.map((group, index) => (
            <div key={group.id} className="specialization-section">
              <div className="specialization-section-first">
                <label className="edit-nurse-general-information-1-heading">{t("serviceGroup")}</label>
                <div className="specialization-section-input">
                  <MultiSelector options={serviceGroupOptions} selectedOptions={selectedServiceGroups} setSelectedOptions={handleServiceGroupChange} />
                </div>
              </div>

              <hr className="edit-nurse-hr" />
              <div className="specialization-section-first">
                <label className="edit-nurse-general-information-1-heading">{t("subServiceGroup")}</label>
                <div className="specialization-section-input">
                  <MultiSelector options={subServiceGroupOptions} selectedOptions={selectedSubServiceGroups} setSelectedOptions={handleSubServiceGroupChange} />
                </div>
              </div>
              <hr className="edit-nurse-hr" />
              <div className="specialization-section-first">
                <label className="edit-nurse-general-information-1-heading">{t("serviceItem")}</label>
                <div className="specialization-section-input">
                  <MultiSelector options={serviceItemsOptions} selectedOptions={selectedServiceItems} setSelectedOptions={setSelectedServiceItems} />
                </div>
              </div>
            </div>
          ))}
          {/* Add Button */}
        </div>
      </div>

      <div className="edit-section-footer-buttons">
        <div className="edit-section-footer-buttons-1">
          <button onClick={() => navigate(strings.navigation.nurseList)}>{t("cancel")}</button>
        </div>
        <div className="edit-section-footer-buttons-2">
          <button onClick={handleSave}>{t("save")}</button>
        </div>
      </div>
      <Widgets.ConfirmModal showModal={showDeleteModal} handleCancel={handleCancelDelete} handleConfirm={handleConfirmDelete} heading={t("delProfile")} description={t("desprofile")} />
    </div>
  );
};

export default EditNurse;
